import { gql } from '@apollo/client';
import { ClientFragment } from '../fragments/ClientFragment';
/**
 * @const CreateClientMutation
 * @since 1.0.0
 */
export const CreateClientMutation = gql `
  mutation CreateClientMutation($input: CreateClientInput!) {
    createClient(input: $input) {
      ...ClientFragment
    }
  }

  ${ClientFragment}
`;
